module.exports = __webpack_public_path__ + "media/site_templates/www.paintersnearme.net.au/images/testimonials-f5599499bc8fae35341416935f53c2b0.jpg";